import { render, staticRenderFns } from "./rep_priv.vue?vue&type=template&id=52ee39c3&scoped=true&"
import script from "./rep_priv.vue?vue&type=script&lang=js&"
export * from "./rep_priv.vue?vue&type=script&lang=js&"
import style0 from "./rep_priv.vue?vue&type=style&index=0&id=52ee39c3&scoped=true&lang=less&"
import style1 from "./rep_priv.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ee39c3",
  null
  
)

export default component.exports